// @ts-check

/** @enum {string} */
export const LibraryAssetCategory = {
	ALL: 'all',
	MINE: 'mine',
	BEEYOU: 'beeyou',
	SHARED: 'shared',
};
